/**
 * @generated SignedSource<<6c4e167f9591bb6beda42d14d8fa6cc0>>
 * @relayHash 716878928b1dcc5b1b422d1897047dd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b3dba8dc7e37fb2efbf43052de7414ebb5cbe4deca9e8c490e28971ce2f1fbfa

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useExportEnabledStateIsExportEnabledQuery$variables = {
  spaceId: string;
};
export type useExportEnabledStateIsExportEnabledQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly isExportEnabled: boolean;
  } | null | undefined;
};
export type useExportEnabledStateIsExportEnabledQuery = {
  response: useExportEnabledStateIsExportEnabledQuery$data;
  variables: useExportEnabledStateIsExportEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "spaceId"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "isExportEnabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useExportEnabledStateIsExportEnabledQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useExportEnabledStateIsExportEnabledQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "716878928b1dcc5b1b422d1897047dd6",
    "id": "b3dba8dc7e37fb2efbf43052de7414ebb5cbe4deca9e8c490e28971ce2f1fbfa",
    "metadata": {},
    "name": "useExportEnabledStateIsExportEnabledQuery",
    "operationKind": "query",
    "text": "query useExportEnabledStateIsExportEnabledQuery($spaceId:ID!){space(id:$spaceId){id,isExportEnabled}}"
  }
};
})();

(node as any).hash = "7dc5ad2fbf18d8407f8dbf38fc1c5d14";

export default node;
